// extracted by mini-css-extract-plugin
module.exports = {"cover":"import_cover__3Zo_S","fileTip":"import_fileTip__1gXUY"};